"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _Suspension = _interopRequireDefault(require("./Suspension"));

var defaults = {
  authorized: true,
  message: '',
  reason: '',
  sendCredits: null,
  source: '',
  suspension: null
};

var PortalEmailStatus =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(PortalEmailStatus, _Record);

  function PortalEmailStatus() {
    (0, _classCallCheck2.default)(this, PortalEmailStatus);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PortalEmailStatus).apply(this, arguments));
  }

  (0, _createClass2.default)(PortalEmailStatus, [{
    key: "isSuspended",
    value: function isSuspended() {
      return this.authorized === false;
    }
  }], [{
    key: "from",
    value: function from(json) {
      if (typeof json.suspension !== 'undefined') {
        json.suspension = _Suspension.default.from(json.suspension);
      }

      return new PortalEmailStatus(json);
    }
  }]);
  return PortalEmailStatus;
}((0, _immutable.Record)(defaults));

var _default = PortalEmailStatus;
exports.default = _default;
module.exports = exports.default;